import React from 'react';
import AttorneyHeader from './AttorneyHeader';
import AttorneySidebar from './AttorneySidebar';

/**
 * Attorney Layout Component
 * Main layout wrapper for attorney dashboard - styled to match admin dashboard
 */
function AttorneyLayout({ children }) {
  return (
    <div className="min-h-screen bg-gray-100">
      <AttorneyHeader />
      <div className="pt-16 flex min-h-screen">
        <AttorneySidebar />
        <main className="ml-64 flex-1 p-6">
          <div className="max-w-6xl mx-auto">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
}

export default AttorneyLayout;
